<template>
  <div class="order-list-container">
    <h2 class="page-title">订单列表</h2>

    <!-- 查询表单 -->
    <div class="search-form">
      <div class="search-row">
        <div class="search-col">
          <div class="form-group">
            <label for="productName">产品名称</label>
            <el-input id="productName" v-model="search.productName" placeholder="模糊查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="sku">SKU</label>
            <el-input id="sku" v-model="search.sku" placeholder="模糊查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="warehouse">仓库</label>
            <el-select id="warehouse" v-model="search.warehouse" placeholder="请选择仓库" :disabled="loading" style="width: 100%" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="加纳" value="GH01"></el-option>
              <el-option label="肯尼亚" value="KE01"></el-option>
              <el-option label="乌干达" value="UG01"></el-option>
              <el-option label="尼日利亚" value="NG01"></el-option>
              <el-option label="巴基斯坦" value="PK02"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search-row">
        <div class="search-col">
          <div class="form-group">
            <label for="startDate">开始日期</label>
            <el-date-picker
              id="startDate"
              v-model="search.startDate"
              type="date"
              placeholder="选择日期"
              :disabled="loading"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="endDate">结束日期</label>
            <el-date-picker
              id="endDate"
              v-model="search.endDate"
              type="date"
              placeholder="选择日期"
              :disabled="loading"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        <div class="search-col" v-if="userInfo.isAdmin || userInfo.roleType === 1">
          <div class="form-group">
            <label for="salesman">销售人员</label>
            <el-input id="salesman" v-model="search.salesman" placeholder="准确查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="orderStatus">订单状态</label>
            <el-select id="orderStatus" v-model="search.orderStatus" placeholder="请选择订单状态" :disabled="loading" style="width: 100%" clearable>
              <el-option 
                v-for="option in orderStatusOptions" 
                :key="option.value" 
                :label="option.label" 
                :value="option.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-col search-button-col">
          <el-button type="primary" @click="handleSearch" :disabled="loading" :loading="loading">
            查询
          </el-button>
        </div>
      </div>
    </div>

    <!-- 订单表格 -->
    <div class="table-container">
      <table>
      <thead class="sticky-header">
        <tr>
          <th style="width: 15%">订单号</th>
          <th style="width: 15%">物流运单号</th>
          <th style="width: 10%">业务员</th>
          <th style="width: 8%">国家</th>
          <th style="width: 15%">产品中文名</th>
          <th style="width: 12%">SKU</th>
          <th style="width: 10%">代收货款</th>
          <th style="width: 10%">订单状态</th>
          <th style="width: 15%">下单时间</th>
        </tr>
      </thead>
        <tbody>
          <!-- 加载中状态 -->
          <tr v-if="loading">
            <td colspan="9" style="text-align: center; padding: 20px;">
              <span v-if="$loading">
                <el-icon>
                  <Loading />
                </el-icon> 加载中...
              </span>
              <span v-else>加载中...</span>
            </td>
          </tr>

          <!-- 错误状态 -->
          <tr v-else-if="error">
            <td colspan="9" style="text-align: center; padding: 20px; color: #f56c6c;">
              {{ error }}
            </td>
          </tr>

          <!-- 无数据状态 -->
          <tr v-else-if="!hasData">
            <td colspan="9" style="text-align: center; padding: 20px;">
              暂无数据
            </td>
          </tr>

        <!-- 数据列表 -->
        <tr v-else v-for="item in orders" :key="item.orderCode + '-' + item.productSku">
          <td>{{ item.referenceNo || '-' }}</td>
          <td class="tracking-link" @click="showLogistics(item)" :class="{ 'disabled': !item.orderCode }">{{ item.trackingNo || '-' }}</td>
          <td>{{ item.salesman || '-' }}</td>
          <td>{{ formatWarehouse(item.warehouse) }}</td>
          <td>{{ item.skuName || '-' }}</td>
          <td>{{ item.productSku || '-' }}</td>
          <td>{{ formatCollectionPayment(item.orderSaleAmount, item.orderSaleCurrency) }}</td>
          <td>{{ formatOrderStatus(item.orderStatus) }}</td>
          <td>{{ formatDate(item.dateCreate) }}</td>
        </tr>
        </tbody>
      </table>

      <!-- 分页控件 -->
      <div class="pagination-container" v-if="hasData">
        <div class="page-size-selector">
          <span>每页显示：</span>
          <el-select v-model="pagination.pageSize" @change="handlePageSizeChange" :disabled="loading" size="small" style="width: 100px">
            <el-option label="10条" value="10"></el-option>
            <el-option label="100条" value="100"></el-option>
            <el-option label="1000条" value="1000"></el-option>
          </el-select>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.totalItems"
          layout="total, prev, pager, next, jumper"
          :page-count="pagination.totalPages"
        >
        </el-pagination>
        <div class="pagination-info">
          <span>显示 {{ pagination.startIndex }}-{{ pagination.endIndex }} 条，共 {{ pagination.totalItems }} 条</span>
        </div>
      </div>
    </div>

    <!-- 悬浮滚动按钮 -->
    <div class="scroll-buttons">
      <button class="scroll-btn scroll-to-top" @click="scrollToTop" title="回到顶部">
        <i class="el-icon-arrow-up"></i>
      </button>
      <button class="scroll-btn scroll-to-bottom" @click="scrollToBottom" title="跳转到底部">
        <i class="el-icon-arrow-down"></i>
      </button>
    </div>

    <!-- 物流信息弹窗 -->
    <div v-if="showLogisticsDialog" class="dialog-overlay" @click.self="closeLogisticsDialog">
    <div class="dialog-content">
      <div class="dialog-header">
        <h3>物流信息 - {{ currentOrderCode }}</h3>
        <button class="close-btn" @click="closeLogisticsDialog">×</button>
      </div>
      <div class="dialog-body">
        <div v-if="logisticsLoading" class="loading-state">
          <el-icon><Loading /></el-icon>
          <span> 正在获取物流信息...</span>
        </div>
        <div v-else-if="logisticsError" class="error-state">
          <span class="error-text">{{ logisticsError }}</span>
        </div>
        <div v-else-if="logisticsData" class="logistics-info">
          <div class="logistics-header" v-if="logisticsData.customerCode">
            <strong>客户编号：</strong>{{ logisticsData.customerCode }}
          </div>
          <div class="logistics-tracks" v-if="logisticsData.tracks && logisticsData.tracks.length > 0">
            <div class="timeline">
              <div v-for="(track, index) in sortedTracks" :key="index" class="timeline-item">
                <div class="timeline-marker"></div>
                <div class="timeline-content">
                  <div class="track-time">{{ track.time }}</div>
                  <div class="track-action">{{ track.actionName }}</div>
                  <div class="track-message">{{ track.message }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-tracks">暂无物流轨迹信息</div>
        </div>
      </div>
      <div class="dialog-footer">
        <button @click="closeLogisticsDialog" :disabled="logisticsLoading">关闭</button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'OrderList',
  data() {
    return {
      search: {
        productName: '',
        sku: '',
        warehouse: '',
        startDate: '',
        endDate: '',
        salesman: '',
        orderStatus: 'ALL'
      },
      // 订单状态枚举
      orderStatusOptions: [
        { value: 'ALL', label: '全部状态' },
        { value: '', label: '无物流' },
        { value: '-1', label: '问题件' },
        { value: '0', label: '待揽收' },
        { value: '1', label: '已揽收' },
        { value: '2', label: '发件' },
        { value: '3', label: '到件' },
        { value: '4', label: '派送中' },
        { value: '5', label: '已签收' },
        { value: '-710', label: '退件中' },
        { value: '730', label: '退货签收' },
      ],
      orders: [],
      loading: false,
      error: null,
      // 物流信息相关
      showLogisticsDialog: false,
      logisticsLoading: false,
      logisticsError: null,
      logisticsData: null,
      currentOrderCode: '',
      pagination: {
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
        pages: [],
        startPage: 0,
        endPage: 0
      }
    }
  },
computed: {
  hasData() {
    return this.orders && this.orders.length > 0
  },
  sortedTracks() {
    if (!this.logisticsData || !this.logisticsData.tracks) {
      return []
    }
    // 按时间排序，最新的在前
    return [...this.logisticsData.tracks].sort((a, b) => {
      return new Date(b.time) - new Date(a.time)
    })
  },
  userInfo() {
    const userInfoStr = localStorage.getItem('userInfo');
    if (userInfoStr) {
      try {
        return JSON.parse(userInfoStr);
      } catch (e) {
        return { isAdmin: false };
      }
    }
    return { isAdmin: false };
  }
},
  created() {
    this.fetchOrderData()
  },
  methods: {
    /**
     * 查询订单数据
     */
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchOrderData()
    },
    
    /**
     * 获取订单数据
     */
    fetchOrderData() {
      this.loading = true
      this.error = null

      const requestData = {
        ...this.search,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      }

      // 移除空字符串值
      Object.keys(requestData).forEach(key => {
        if (requestData[key] === null || requestData[key] === undefined) {
          delete requestData[key]
        }
      })

      this.axios.post('/data-serv/order/list', requestData)
        .then(response => {
          if (response.data.code === 0 && response.data.data) {
            const data = response.data.data
            this.pagination.totalItems = data.totalRows || 0
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
            this.orders = data.list || []

            // 计算分页显示范围
            this.calculatePagination()
          } else {
            throw new Error(response.data.message || '获取订单数据失败')
          }
        })
        .catch(error => {
          console.error('获取订单数据失败:', error)
          this.error = error.message || '获取订单数据失败'
          this.orders = []
          this.pagination.totalItems = 0
          this.pagination.totalPages = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * 计算分页
     */
    calculatePagination() {
      const maxVisiblePages = 7
      let startPage = Math.max(1, this.pagination.currentPage - Math.floor(maxVisiblePages / 2))
      let endPage = Math.min(this.pagination.totalPages, startPage + maxVisiblePages - 1)
      
      // 调整起始页，确保显示足够的页面
      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1)
      }

      this.pagination.startPage = startPage
      this.pagination.endPage = endPage

      // 生成分页数组
      this.pagination.pages = []
      for (let i = startPage; i <= endPage; i++) {
        this.pagination.pages.push(i)
      }

      // 计算显示范围
      this.pagination.startIndex = (this.pagination.currentPage - 1) * this.pagination.pageSize + 1
      this.pagination.endIndex = Math.min(this.pagination.currentPage * this.pagination.pageSize, this.pagination.totalItems)
    },

    /**
     * 处理当前页码变化
     */
    handleCurrentChange(page) {
      if (page < 1 || page > this.pagination.totalPages || page === this.pagination.currentPage) {
        return
      }
      this.pagination.currentPage = page
      this.fetchOrderData()
    },

    /**
     * 处理每页条数变化
     */
    handlePageSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.currentPage = 1
      this.fetchOrderData()
    },

    /**
     * 格式化仓库显示
     */
    formatWarehouse(warehouseCode) {
      const warehouseMap = {
        'GH01': '加纳',
        'KE01': '肯尼亚',
        'UG01': '乌干达',
        'NG01': '尼日利亚',
        'PK02': '巴基斯坦'
      }
      return warehouseMap[warehouseCode] || warehouseCode || '-'
    },

    /**
     * 格式化订单状态显示
     */
    formatOrderStatus(statusCode) {
      if (statusCode === "") {
        return "-";
      }
      const status = this.orderStatusOptions.find(option => option.value === statusCode)
      return status ? status.label : (statusCode || '-')
    },

    /**
     * 格式化代收货款显示
     */
    formatCollectionPayment(amount, currency) {
      if (!amount && !currency) {
        return '-';
      }
      return `${amount || ''} ${currency || ''}`.trim() || '-';
    },

    /**
     * 显示物流信息
     */
    showLogistics(item) {
      this.currentOrderCode = item.orderCode
      this.showLogisticsDialog = true
      this.logisticsError = null
      this.logisticsData = null
      this.fetchLogisticsInfo(item.orderCode)
    },

    /**
     * 关闭物流信息弹窗
     */
    closeLogisticsDialog() {
      this.showLogisticsDialog = false
      this.logisticsLoading = false
      this.logisticsError = null
      this.logisticsData = null
      this.currentOrderCode = ''
    },

    /**
     * 获取物流信息
     */
    fetchLogisticsInfo(orderCode) {
      this.logisticsLoading = true
      this.logisticsError = null

      this.axios.get('/data-serv/express/query', {
        params: {
          orderId: orderCode
        }
      })
        .then(response => {
          if (response.data && response.data.code === 0) {
            this.logisticsData = response.data.data
          } else {
            throw new Error(response.data.message || '获取物流信息失败')
          }
        })
        .catch(error => {
          console.error('获取物流信息失败:', error)
          this.logisticsError = error.message || '获取物流信息失败'
        })
        .finally(() => {
          this.logisticsLoading = false
        })
    },

    /**
     * 格式化物流数据显示
     */
    formatLogisticsData(data) {
      if (!data) return '暂无物流信息'
      
      // 如果数据是对象，转换为格式化的JSON字符串
      if (typeof data === 'object') {
        return JSON.stringify(data, null, 2)
      }
      
      // 如果数据已经是字符串，直接返回
      return data
    },

    /**
     * 格式化日期
     */
    formatDate(dateStr) {
      if (!dateStr) return '-'
      try {
        const date = new Date(dateStr)
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (e) {
        return dateStr
      }
    },

    /**
     * 滚动到页面顶部
     */
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    /**
     * 滚动到页面底部
     */
    scrollToBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.order-list-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100%;
  box-sizing: border-box;
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
  text-align: center;
}

/* 查询表单样式 */
.search-form {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.search-row {
  display: flex;
  margin-bottom: 15px;
  gap: 15px;
}

.search-col {
  flex: 1;
  min-width: 0;
}

.search-button-col {
  flex: 0 0 100px;
  display: flex;
  align-items: flex-end;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

/* 表格样式 */
.table-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-container table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #f5f7fa;
  z-index: 10;
}

/* 物流运单号链接样式 */
.table-container td.tracking-link {
  color: #67c23a;
  cursor: pointer;
  text-decoration: underline;
}

.table-container td.tracking-link:hover:not(.disabled) {
  color: #85ce61;
  background-color: #f5f7fa;
}

.table-container td.tracking-link.disabled {
  color: #95d373;
  cursor: not-allowed;
  text-decoration: none;
  background-color: transparent;
}

.table-container th {
  text-align: center;
  padding: 12px 16px;
  font-weight: 600;
  color: #606266;
  border-bottom: 1px solid #ebeef5;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-container td {
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-word;
}

.table-container tr:hover {
  background-color: #f5f7fa;
}


/* 分页样式 */
.pagination-container {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  border-top: 1px solid #ebeef5;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #606266;
}

.pagination-info {
  font-size: 14px;
  color: #606266;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .order-list-container {
    padding: 10px;
  }

  .search-row {
    flex-direction: column;
    gap: 10px;
  }

  .search-col {
    flex: none;
  }

  .search-button-col {
    flex: none;
    align-items: stretch;
  }

  .table-container th,
  .table-container td {
    padding: 8px 12px;
    font-size: 12px;
  }

  .pagination-container {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }

  .page-size-selector {
    justify-content: center;
  }

  .pagination-info {
    text-align: center;
  }
}

/* 物流信息弹窗样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.dialog-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #666;
}

.dialog-body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #409eff;
}

.error-state {
  padding: 20px;
  text-align: center;
  color: #f56c6c;
}

.error-text {
  font-size: 14px;
}

.logistics-info {
  padding: 10px 0;
}

/* 不再使用pre格式，改为时间线样式，所以可以删除上面的.logistics-content样式 */
.dialog-body {
  padding: 0;
}

.logistics-header {
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
  font-size: 16px;
  color: #303133;
}

.logistics-info {
  padding: 0;
}

.logistics-tracks {
  max-height: 60vh;
  overflow-y: auto;
}

.timeline {
  padding: 20px;
  position: relative;
}

.timeline-item {
  display: flex;
  margin-bottom: 20px;
  position: relative;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-item::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 20px;
  bottom: -20px;
  width: 2px;
  background-color: #e4e7ed;
}

.timeline-item:last-child::before {
  display: none;
}

.timeline-marker {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #409eff;
  border: 3px solid white;
  box-shadow: 0 0 0 2px #409eff;
  margin-right: 15px;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.timeline-content {
  flex: 1;
  min-width: 0;
}

.track-time {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.track-action {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.track-message {
  font-size: 14px;
  color: #606266;
  line-height: 1.4;
}

.no-tracks {
  padding: 40px 20px;
  text-align: center;
  color: #909399;
  font-size: 14px;
}

.dialog-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
}

.dialog-footer button {
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  background-color: white;
  border: 1px solid #d9d9d9;
  color: #666;
}

.dialog-footer button:hover:not(:disabled) {
  border-color: #40a9ff;
  color: #40a9ff;
}

.dialog-footer button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .search-form {
    padding: 15px;
  }

  .table-container th,
  .table-container td {
    padding: 6px 8px;
    font-size: 11px;
  }
}

/* 悬浮滚动按钮样式 */
.scroll-buttons {
  position: fixed;
  right: 30px;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.scroll-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background-color: #909399;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.scroll-btn .el-icon-arrow-up,
.scroll-btn .el-icon-arrow-down {
  font-size: 24px;
  color: white;
}

.scroll-btn:hover {
  background-color: #a6a9ad;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.scroll-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 响应式设计 - 移动端隐藏悬浮按钮 */
@media (max-width: 768px) {
  .scroll-buttons {
    display: none;
  }
}
</style>